/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiSanctionEntityType } from './ApiSanctionEntityType';
import {
    ApiSanctionEntityTypeFromJSON,
    ApiSanctionEntityTypeFromJSONTyped,
    ApiSanctionEntityTypeToJSON,
    ApiSanctionEntityTypeToJSONTyped,
} from './ApiSanctionEntityType';
import type { ApiPerson } from './ApiPerson';
import {
    ApiPersonFromJSON,
    ApiPersonFromJSONTyped,
    ApiPersonToJSON,
    ApiPersonToJSONTyped,
} from './ApiPerson';
import type { ApiTransaction } from './ApiTransaction';
import {
    ApiTransactionFromJSON,
    ApiTransactionFromJSONTyped,
    ApiTransactionToJSON,
    ApiTransactionToJSONTyped,
} from './ApiTransaction';

/**
 * 
 * @export
 * @interface ApiSanctionEntity
 */
export interface ApiSanctionEntity {
    /**
     * 
     * @type {number}
     * @memberof ApiSanctionEntity
     */
    id: number;
    /**
     * 
     * @type {ApiSanctionEntityType}
     * @memberof ApiSanctionEntity
     */
    entityType: ApiSanctionEntityType;
    /**
     * 
     * @type {ApiPerson}
     * @memberof ApiSanctionEntity
     */
    person?: ApiPerson;
    /**
     * 
     * @type {ApiTransaction}
     * @memberof ApiSanctionEntity
     */
    transaction?: ApiTransaction;
}



/**
 * Check if a given object implements the ApiSanctionEntity interface.
 */
export function instanceOfApiSanctionEntity(value: object): value is ApiSanctionEntity {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    return true;
}

export function ApiSanctionEntityFromJSON(json: any): ApiSanctionEntity {
    return ApiSanctionEntityFromJSONTyped(json, false);
}

export function ApiSanctionEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSanctionEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'entityType': ApiSanctionEntityTypeFromJSON(json['entityType']),
        'person': json['person'] == null ? undefined : ApiPersonFromJSON(json['person']),
        'transaction': json['transaction'] == null ? undefined : ApiTransactionFromJSON(json['transaction']),
    };
}

export function ApiSanctionEntityToJSON(json: any): ApiSanctionEntity {
    return ApiSanctionEntityToJSONTyped(json, false);
}

export function ApiSanctionEntityToJSONTyped(value?: ApiSanctionEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'entityType': ApiSanctionEntityTypeToJSON(value['entityType']),
        'person': ApiPersonToJSON(value['person']),
        'transaction': ApiTransactionToJSON(value['transaction']),
    };
}

